module.exports = __webpack_public_path__ + "img/blank.93301c3e.png";